export default __webpack_public_path__ + "static/media/skovstykket-townhouse-4-rooms-09.ee6afb57.jpg";